export function baseUrl(path: string = '') {
  const { BASE_URL, PROD } = import.meta.env
  const isAbsolute = new RegExp('^(?:[a-z+]+:)?//', 'i').test(path ?? '')
  if (!isAbsolute) {
    if (PROD && BASE_URL == './') {
      path = window.location.origin + (window.location.pathname + path).replace(/\/\/+/g, '/')
    } else {
      path = (BASE_URL + path).replace(/\/\/+/g, '/')
    }
  }
  return path
}
